<ion-footer
  id="header"
  [ngClass]="{
    'red-web-footer': (useMobileLayout$ | async) === false
  }"
>
  <ng-content></ng-content>
</ion-footer>
